import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container, Button } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.png'

const RecoverPassword = (cp) => {
  switch (cp) {
    case 'dummy2':
      return (
        <p><a href="http://extranet.telconet.ec:8080/foxPremium" target="_blank" without rel="noopener noreferrer">¿OLVIDÓ SU CONTRASEÑA?</a></p>
      );
    case 'fp':
      return (
        <p><a href="https://www.netlife.ec/foxPremium" target="_blank" without rel="noopener noreferrer">¿OLVIDÓ SU CONTRASEÑA?</a></p>
      );
    case 'paramountlatam':
      return (
        <p><a href="https://www.netlife.ec/Paramount" target="_blank" without rel="noopener noreferrer">¿OLVIDÓ SU CONTRASEÑA?</a></p>
      );
    case 'nogginlatam':
      return (
        <p><a href="https://www.netlife.ec/Noggin" target="_blank" without rel="noopener noreferrer">¿OLVIDÓ SU CONTRASEÑA?</a></p>
      );
    default:
      break;
  }
}


const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  const cp = parameters.cp_convert
  parameters.idp = 'netlife';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const changeInputType = () => {
    if (showPassword) return 'text'
    return 'password'
  }
  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
        producto: cp === 'dummy2' ? 'paramountlatam' : cp
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "Usuário e/ou senha inválidos.";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-netlife-container" ref={nodeRef}>
        <Form onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="netlife-form-container">
            <img src={logo} alt="logo" className="logo-netlife rounded mx-auto d-block" />
            <div className="netlife-title">INICIAR SESIÓN</div>
            <Row className="netlife-form-body">
              <Col sm="12" xs="12" md="12" className="netlife-input">
                <span className="netlife-input-icon">
                  <i class="fa fa-user"></i>
                </span>
                <Input
                  className="user-input-netlife"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  onChange={e => setUsername(e.target.value)}
                />
              </Col>
              <Col sm="12" xs="12" md="12" className="netlife-input">
                <span className="netlife-input-icon">
                  <i class="fa fa-lock"></i>
                </span>
                <Input
                  className="pass-input-netlife"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type={changeInputType()}
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  onChange={e => setPassword(e.target.value)}
                />
                <div className="netlife-btn-icon">
                  <Button className="iconBtn" onClick={() => setShowPassword(!showPassword)}>
                    <i class="fa fa-eye"></i>
                  </Button>
                </div>
              </Col>
              <Col sm="12" xs="12" md="12" className="netlife-input">
                {!onLogin ? (
                  <button
                    block={!parameters.failureRedirect}
                    tabIndex={1}
                    type="submit"
                    id="submmit"
                    className="enter-netlife"
                    disabled={!props.turnstileSuccess}
                  >
                    {translate("ButtonEnter")}
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
                <div className="netlife-links">
                  {RecoverPassword(cp)}
                  <p>Legales todos los derechos reservados</p>
                </div>
              </Col>
            </Row>
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
          </Container>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm);
